import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
function removecontainer(imagePath, maskPath, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      3: {
        inputs: {
          vae_name: 'ae.safetensors'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      5: {
        inputs: {},
        class_type: 'FluxKontextImageScale',
        _meta: {
          title: 'FluxKontextImageScale'
        }
      },
      8: {
        inputs: {
          text: 'Remove the content in the picture.',
          clip: [
            '25',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Positive Prompt)'
        }
      },
      10: {
        inputs: {
          guidance: 2.5,
          conditioning: [
            '8',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      13: {
        inputs: {
          seed: seed,
          steps: 20,
          cfg: 1,
          sampler_name: 'euler',
          scheduler: 'simple',
          denoise: 1,
          model: [
            '24',
            0
          ],
          positive: [
            '22',
            0
          ],
          negative: [
            '10',
            0
          ],
          latent_image: [
            '22',
            1
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      14: {
        inputs: {
          samples: [
            '13',
            0
          ],
          vae: [
            '3',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      22: {
        inputs: {
          noise_mask: true,
          conditioning: [
            '10',
            0
          ],
          vae: [
            '3',
            0
          ],
          pixels: [
            '39',
            0
          ],
          mask: [
            '43',
            0
          ]
        },
        class_type: 'Kontext Inpainting Conditioning',
        _meta: {
          title: 'Kontext Inpainting Conditioning'
        }
      },
      24: {
        inputs: {
          model_path: 'svdq-int4_r32-flux.1-kontext-dev.safetensors',
          cache_threshold: 0,
          attention: 'nunchaku-fp16',
          cpu_offload: 'auto',
          device_id: 0,
          data_type: 'bfloat16',
          i2f_mode: 'enabled'
        },
        class_type: 'NunchakuFluxDiTLoader',
        _meta: {
          title: 'Nunchaku FLUX DiT Loader'
        }
      },
      25: {
        inputs: {
          model_type: 'flux',
          text_encoder1: 't5xxl_fp8_e4m3fn.safetensors',
          text_encoder2: 'clip_l.safetensors',
          t5_min_length: 512,
          use_4bit_t5: 'disable',
          int4_model: 'none'
        },
        class_type: 'NunchakuTextEncoderLoader',
        _meta: {
          title: 'Nunchaku Text Encoder Loader (Deprecated)'
        }
      },
      38: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '14',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      39: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: '原始图片'
        }
      },
      40: {
        inputs: {
          image_url: maskPath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: '遮罩'
        }
      },
      41: {
        inputs: {
          channel: 'red',
          image: [
            '40',
            0
          ]
        },
        class_type: 'AC_Img2Mask',
        _meta: {
          title: 'AC_Img2Mask'
        }
      },
      43: {
        inputs: {
          mask: [
            '41',
            0
          ]
        },
        class_type: 'InvertMask',
        _meta: {
          title: 'InvertMask'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 38 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  removecontainer
}
